var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-search-results-group"},[_c('strong',[_vm._v(_vm._s(_vm.resultsGroup.title))]),_vm._v(" "),_c('ul',_vm._l((_vm.resultsGroup.entries),function(result){return _c('DSearchResult',{key:`${ _vm.resultsGroup.type }-${ result.id }`,attrs:{"result":result,"title":result.label,"result-type":_vm.resultsGroup.type}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }